import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/testimonials/page.tsx");
